import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

import Cookies from "js-cookie";
import { pdf, PDFDownloadLink } from "@react-pdf/renderer";
import Paginate from "../../../components/Paginate/Paginate";
import CustomLoader from "../../../components/Loading/TopBarLoader";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import MDButton from "../../../components/MDButton";
import { ShimmerPostList } from "react-shimmer-effects";
import { Modal } from "@mui/material";
import calculateTimeDifference from "../../../extension/differenceDate";
import PdfFunctionRegistration from "../../../actions/pdf_part/PdfReportFunctionRegistration/PdfFunctionRegistration";
import * as XLSX from "xlsx";
import PelakComponent from "../../../components/Pelak/pelakComponent";
import { FaTrash } from "react-icons/fa";
import { deleteFunction, downloadAllReport } from "../../../actions/function_registration/function_registration";
import { Button } from "@heroui/button";
import PdfTotalPage from "../../../actions/pdf_part/PdfTotal/PdfTotalExport";

export default function ReportFunctionRegistrationListPage() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedJens, setSelectedJens] = useState([]);

    const handleOpenModal = (jensList) => {
        setSelectedJens(jensList);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedJens([]);
    };
    const [reportData, setReportData] = useState([]);
    const [paging, setPaginate] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingExport, setLoadingExport] = useState(false);
    const [loadingExportPdf, setLoadingExportPdf] = useState(false);
    const [searchParams] = useSearchParams();
    const [selectedItems, setSelectedItems] = useState([]);
    const navigate = useNavigate();
    const handleCheckboxChange = (item) => {
        if (selectedItems.includes(item)) {
            setSelectedItems(selectedItems.filter(i => i.id !== item.id));
        } else {
            setSelectedItems([...selectedItems, item]);
        }
    };
    const payload = localStorage.getItem('reportPayloadFunctionRegistration');

    useEffect(() => {

        if (payload) {
            const params = new URLSearchParams(searchParams);
            const fetchData = async () => {
                try {
                    const token = Cookies.get('login_token');

                    setLoading(true);
                    const parsedPayload = JSON.parse(payload);

                    params.forEach((value, key) => {
                        parsedPayload[key] = value;
                    });

                    const response = await axios.post(`${process.env.REACT_APP_API_URL}/ReportWeb/Reports/report-function-registration`, parsedPayload,
                        {
                            headers: {
                                'Authorization': `Bearer ${token}`,
                                'Content-Type': 'application/json'
                            }
                        });
                    setReportData(response.data.data);
                    setPaginate(response.data.meta.links);
                    setLoading(false);
                } catch (error) {
                    if (axios.isAxiosError(error)) {
                        const axiosError = error;
                        if (axiosError.response && axiosError.response.status === 401) {
                            toast.error('نشست منقضی شده !');

                            navigate('/authentication/sign-in')
                        }
                        return {
                            status: 'error',
                            message: axiosError.message || 'خطا در اتصال به سرور'
                        };
                    }
                    toast.error('خطا در دریافت اطلاعات!');
                }
            };
            fetchData();
        }
    }, [searchParams]);
    const exportToExcel = async () => {
        console.log(selectedItems);
        const data = selectedItems.map((item) => ({
            "تاریخ و ساعت": item.date || "",
            "شرح": item.desc || "",
            "تاریخ شروع": item.startDate || "",
            "تاریخ پایان": item.endDate || "",
            "ساعت شروع": item.startTime || "",
            "ساعت پایان": item.endTime || "",
            "دستگاه": item.machine?.name || "",
            "راننده": item.driver?.name || "",
            "پلاک": item.machine?.pelak || "",
            "نوع دستگاه": item.machine?.type || "",
            "ساعت مجاز": item.allowTime || "",
            "ساعت اضافه کاکرد": item.overTime || "",
            "ساعت کار تایید": item.approvedTime || "",
            "میزان کارکرد": calculateTimeDifference(item.startDate, item.startTime, item.endDate, item.endTime) || "",
            "محل استقرار": item.location?.name || "",
            "پیمانکار": item.peymankar?.name || "",
            "تجهیز بارگیری": item.equipment?.name || "",
            "اپراتور": item.operator?.name || "",
            "نام مسئول عملیات": item.user?.name || ""
        }));


        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Bargo');
        XLSX.writeFile(workbook, 'گزارشات-کارکرد-بارگو.xlsx');
    };
    const exportAllToExcel = async () => {
        setLoadingExport(true)
        const res = await downloadAllReport();

        const dataArray = Array.isArray(res.message.data) ? res.message.data : [];

        const data = dataArray.map((item) => ({
            "تاریخ و ساعت": item.date || "",
            "شرح": item.desc || "",
            "تاریخ شروع": item.startDate || "",
            "تاریخ پایان": item.endDate || "",
            "ساعت شروع": item.startTime || "",
            "ساعت پایان": item.endTime || "",
            "دستگاه": item.machine?.name || "",
            "راننده": item.driver?.name || "",
            "پلاک": item.machine?.pelak || "",
            "نوع دستگاه": item.machine?.type || "",
            "ساعت مجاز": item.allowTime || "",
            "ساعت اضافه کاکرد": item.overTime || "",
            "ساعت کار تایید": item.approvedTime || "",
            "میزان کارکرد": calculateTimeDifference(item.startDate, item.startTime, item.endDate, item.endTime) || "",
            "محل استقرار": item.location?.name || "",
            "پیمانکار": item.peymankar?.name || "",
            "تجهیز بارگیری": item.equipment?.name || "",
            "اپراتور": item.operator?.name || "",
            "نام مسئول عملیات": item.user?.name || ""
        }));

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Bargo');
        XLSX.writeFile(workbook, 'گزارشات-کارکرد-بارگو.xlsx');
        setLoadingExport(false)
    };

    const downloadAllToPdf = async () => {
        setLoadingExportPdf(true);
        const res = await downloadAllReport();

        const dataArray = Array.isArray(res.message.data) ? res.message.data : [];

        console.log(dataArray);
        console.log(selectedItems);

        const blob = await pdf(<PdfFunctionRegistration data={dataArray} />).toBlob();

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "bargo-report-function.pdf";
        link.click();
        setLoadingExportPdf(false)
    }

    return (
        <div>
            <CustomLoader isLoading={loading}/>
            <DashboardLayout>
                <div className={"flex w-full items-center gap-4"}>

                    {selectedItems.length > 0 &&
                      <PDFDownloadLink
                        className="flex items-center px-5 py-2.5 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        document={<PdfFunctionRegistration data={selectedItems}/>}
                        fileName="bargo-function-report.pdf"
                      >
                          خروجی پی دی اف
                          <img src="/images/pdf.svg" alt="" className="w-5 h-5 ms-4"/>

                      </PDFDownloadLink>
                    }
                    {selectedItems.length > 0 &&
                      <Button
                        color={"success"}
                        onClick={() => {
                            exportToExcel()
                        }}
                        isLoading={loadingExport}
                        className="flex items-center px-5 py-2.5 text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                      >
                          {loadingExport ? 'درحال دریافت گزارش...' : 'خروجی اکسل'}
                          <img src="/images/excel.svg" alt="" className="w-5 h-5 ms-4"/>
                      </Button>
                    }
                    <Button
                      color="success"
                      onClick={() => exportAllToExcel()}
                      isLoading={loadingExport}
                      className="flex items-center px-5 py-2.5 text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                    >
                        {loadingExport ? "درحال دریافت گزارش..." : "خروجی اکسل تمامی گزارشات"}
                        <img src="/images/excel.svg" alt="" className="w-5 h-5 ms-4" />
                    </Button>
                    <Button
                      color="primary"
                      onClick={() => downloadAllToPdf()}
                      isLoading={loadingExportPdf}
                      className="flex items-center px-5 py-2.5 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    >
                        {loadingExportPdf ? "درحال دریافت گزارش..." : "خروجی پی دی اف تمامی گزارشات"}
                        <img src="/images/pdf.svg" alt="" className="w-5 h-5 ms-4"/>
                    </Button>
                </div>
                {loading ?  <div className={"mt-5"}>
                      <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} />
                  </div>
                  :  <div className="mt-5 relative overflow-x-auto shadow-md sm:rounded-lg">

                    <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                        <thead
                            className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th className="px-6 py-3">انتخاب</th>
                            <th scope="col" className="px-6 py-3">
                                تاریخ و ساعت
                            </th>
                            <th scope="col" className="px-6 py-3">
                                تاریخ شروع
                            </th>
                            <th scope="col" className="px-10 text-center py-3">
                                تاریخ پایان
                            </th>
                            <th scope="col" style={{ whiteSpace: "nowrap" }} className="px-6 py-3">
                                ساعت شروع
                            </th>
                            <th scope="col" style={{ whiteSpace: "nowrap" }} className="px-10 text-center py-3">
                                ساعت پایان
                            </th>
                            <th scope="col" style={{ whiteSpace: "nowrap" }} className="px-10 text-center py-3">
                                ساعت مجاز
                            </th>
                            <th scope="col" style={{ whiteSpace: "nowrap" }} className="px-10 text-center py-3">
                                ساعت اضافه کارکرد
                            </th>
                            <th scope="col" style={{ whiteSpace: "nowrap" }} className="px-10 text-center py-3">
                              ساعت کار تایید
                            </th>
                            <th scope="col" style={{ whiteSpace: "nowrap" }} className="px-10 text-center py-3">
                                میزان کارکرد
                            </th>
                            <th scope="col" className="px-16 text-center justify-center w-full py-3"
                                style={{ whiteSpace: "nowrap" }}>
                                محل استقرار
                            </th>
                            <th scope="col" className="px-16 text-center justify-center w-full py-3"
                                style={{ whiteSpace: "nowrap" }}>
                                پیمانکار
                            </th>
                            <th scope="col" className="px-10 py-3">
                                دستگاه
                            </th>
                            <th scope="col" className="px-10 py-3">
                                پلاک
                            </th>
                            <th scope="col" className="px-10 py-3" style={{ whiteSpace: "nowrap" }}>
                                نوع دستگاه
                            </th>
                            <th scope="col" className="px-16 py-3">
                                راننده
                            </th>
                            <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                                تجهیز بارگیری
                            </th>
                            <th scope="col" className="px-16 py-3">
                                اپراتور
                            </th>
                            <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                                نام مسئول عملیات
                            </th>
                            <th scope="col" className="px-16 py-3">
                                توضیحات
                            </th>
                            <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                                نوع گزارش
                            </th>
                            <th scope="col" className="px-10 py-3" style={{ whiteSpace: "nowrap" }}>
                                عملیات
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {reportData.map((item, index) => (
                            <tr
                                className="border-b bg-white hover:bg-gray-50 dark:bg-boxdark dark:border-gray-700 dark:hover:bg-gray-600"
                                key={index}
                            >
                                <td className="px-6 py-4">
                                    <input
                                        type="checkbox"
                                        checked={selectedItems.includes(item)}
                                        onChange={() => handleCheckboxChange(item)}
                                    />
                                </td>
                                <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white"
                                    style={{ whiteSpace: "nowrap" }}>
                                    {item["created_at"] ? item["created_at"] :
                                      <span className={"font-normal"}>ثبت نشده</span>
                                    }
                                </td>
                                <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item["startDate"] ? item["startDate"] :
                                      <span className={"font-normal"}>ثبت نشده</span>
                                    }
                                </td>
                                <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white"  style={{whiteSpace:'nowrap'}}>
                                    {item["endDate"] ? item["endDate"] :
                                      <span className={"font-normal"}>ثبت نشده</span>
                                    }
                                </td>
                                <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item["startTime"] ? item["startTime"] :
                                      <span className={"font-normal"}>ثبت نشده</span>
                                    }
                                </td>
                                <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white"  style={{whiteSpace:'nowrap'}}>
                                    {item["endTime"] ? item["endTime"] :
                                      <span className={"font-normal"}>ثبت نشده</span>
                                    }
                                </td>
                                <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white"  style={{whiteSpace:'nowrap'}}>
                                    {item["allowTime"] ? item["allowTime"] :
                                      <span className={"font-normal"}>ثبت نشده</span>
                                    }
                                </td>
                                <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white"  style={{whiteSpace:'nowrap'}}>
                                    {item["overTime"] ? item["overTime"] :
                                      <span className={"font-normal"}>ثبت نشده</span>
                                    }
                                </td>
                                <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white"  style={{whiteSpace:'nowrap'}}>
                                    {item["approvedTime"] ? item["approvedTime"] :
                                      <span className={"font-normal"}>ثبت نشده</span>
                                    }
                                </td>
                                <td className="py-4 text-center justify-center font-semibold text-gray-900 dark:text-white">
                                    {calculateTimeDifference(item['startDate'],item['startTime'], item['endDate'],item['endTime'])} ساعت
                                </td>
                                <td className="py-4 text-center justify-center font-semibold text-gray-900 dark:text-white">
                                    {item['location'] && item['location']['name'] ? (
                                        item['location']['name']
                                    ) : (
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    )}
                                </td>
                                <td className="py-4 text-center justify-center font-semibold text-gray-900 dark:text-white">
                                    {item['peymankar'] && item['peymankar']['name'] ? (
                                      item['peymankar']['name']
                                    ) : (
                                      <span className={"font-normal"}>ثبت نشده</span>
                                    )}
                                </td>
                                <td className="text-center justify-center py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['machine'] && item['machine']['name'] ? (
                                        item['machine']['name']
                                    ) : (
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    )}
                                </td>
                                <PelakComponent pelak={item['machine']['pelak']} />
                                <td className="text-center justify-center py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['machine'] && item['machine']['type'] ? (
                                        item['machine']['type']
                                    ) : (
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    )}
                                </td>

                                <td className="text-center justify-center py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['driver'] && item['driver']['name'] ? (
                                        item['driver']['name']
                                    ) : (
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    )}
                                </td>
                                <td className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['equipment'] && item['equipment']['name'] ? (
                                        item['equipment']['name']
                                    ) : (
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    )}
                                </td>
                                <td className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['operator'] && item['operator']['name'] ? (
                                        item['operator']['name']
                                    ) : (
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    )}
                                </td>
                                <td className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['user'] && item['user']['name'] ? (
                                        item['user']['name']
                                    ) : (
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    )}
                                </td>
                                <td className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['desc'] ? item['desc'] :
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    }
                                </td>
                                <td className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                      <span className={"text-blue-600"}>کارکرد</span>
                                </td>
                                <td className="flex p-4 gap-4">
                                    <MDButton
                                      color={"error"}
                                      style={{whiteSpace:'nowrap'}}
                                      onClick={async() => {
                                          if(!window.confirm('آیا میخواهید این گزارش حذف شود؟')) {
                                              return;
                                          }
                                          await deleteFunction({id: item['id']}).then((res)=>{
                                              toast.success('با موفقیت حذف شد!');
                                              window.location.reload();
                                          }).catch((e)=>{
                                              toast.error('خطا در حذف گزارش!');
                                          });
                                      }}
                                      className="custom-link text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center gap-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
                                    >
                                        <FaTrash className="text-base" />
                                        حذف
                                    </MDButton>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>

                </div>}

                {paging.length > 1 ? <Paginate links={paging}/> : null}

            </DashboardLayout>
            {isModalOpen && (
              <Modal
                open={isModalOpen}
                className="mt-10 absolute inset-0 flex justify-center items-center z-10"
                onClick={handleCloseModal}
              >
                    <div
                        className="bg-white no-scrollbar overflow-y-auto h-1/2 dark:bg-boxdark p-6 rounded-lg max-w-3xl w-full shadow-lg"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex justify-between items-center mb-6 border-b border-gray pb-4">
                            <h2 className="text-xl font-bold text-gray-700 dark:text-white">لیست کالا</h2>
                            <button
                                onClick={handleCloseModal}
                                type="button"
                                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm h-8 w-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            >
                                <svg
                                    className="w-3 h-3"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 14 14"
                                >
                                    <path
                                        stroke="currentColor"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                                    />
                                </svg>
                                <span className="sr-only">Close modal</span>
                            </button>
                        </div>
                        <div className="mb-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {selectedJens.map((subItem, index) => (
                                <div
                                    key={index}
                                    className="bg-gray-50 dark:bg-gray-800 rounded-lg shadow-md p-4 hover:shadow-lg transition-shadow duration-300"
                                >
                                    <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                                        کالا: {subItem["jens"]["title"]}
                                    </div>
                                    <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                                        کد کالا: {subItem["jens_code"]["title"]}
                                    </div>
                                    <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                                        تعداد: {subItem["jens_unit"]}
                                    </div>
                                    <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                                        شماره کالا: {subItem["jens_number"]}
                                    </div>
                                    <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                                        واحد: {subItem["weight"]["title"]}
                                    </div>
                                    <div className="text-gray-700 text-lg dark:text-gray-200">
                                        وزن: {subItem["weight_unit"]}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <MDButton
                          color={"error"}
                            onClick={handleCloseModal}
                            className="mt-6 text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
                        >
                            بستن
                        </MDButton>
                    </div>
                </Modal>
            )}
        </div>
    );
}
